<script>
import Vue from 'vue'
import {mapActions} from "vuex";
import util from "../../untils/util";

export default Vue.extend({
  name: "allFaq",
  computed: {
    util() {
      return util
    }
  },
  data() {
    return {
      totalFaqs: 0,
      faqs: [],
      activeNames: [1],
    }
  },
  methods: {
    ...mapActions('faq', ['getAllFaqList',]),
    retrieveAllFaqList() {
      this.getAllFaqList({params: {}, callback: this.callback})
    },
    callback(resp, status) {
      switch (status) {
        case 'getAllFaqListCallback':
          console.log('getAllFaqListCallback: ', resp.data.list)
          if (resp.code == 0) {
            this.faqs = resp.data
          } else {
            Utils.alert('', resp.message, 'error')
          }
          break;
        default:
          break;
      }
    },
    goBack() {
      this.$router.go(-1)
    },
  },
  mounted() {
    this.retrieveAllFaqList()
  }
})
</script>

<template>
  <div class="referrer_box">
    <el-row>
      <el-col :span="12">
        <span class="page-title">FAQ's</span>
      </el-col>
      <el-col :span="12" class="back-col">
        <span @click="goBack()" class="btn-back"><i class="el-icon-arrow-left"></i>BACK</span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24">
        <el-collapse v-model="activeNames">
          <el-collapse-item :name="faq.position" v-for="faq in faqs" :key="faq.id">
            <template v-slot:title>
              <span class="accordion-question">{{ faq.question }}</span>
            </template>
            <template v-slot:default>
              <span class="accordion-answer">{{ faq.answer }}</span>
            </template>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
.referrer_box {
  border-radius: 0 0 5px 5px;
  background-color: #ffffff;
  padding: 20px 10px 0 10px;
}

.back-col {
  display: flex;
  justify-content: flex-end;
}

.page-title {
  color: #003333;
  font-weight: 600;
  font-size: 24px;
}

.accordion-question {
  color: #003333;
  font-weight: 500;
  font-size: 18px;
  line-height: 125%;
}

.accordion-answer {
  color: #003333;
  font-weight: 500;
  font-size: 16px;
  line-height: 125%;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/faq/viewFaq.vue